import { type FC, type Fragment, type JSX } from 'react';
import { Link, type LinkProps } from 'dibs-elements/exports/Link';
import { SeoLink, type SeoLinkProps } from 'dibs-elements/exports/SeoLink';
import { isRecordWith } from 'dibs-ts-utils/exports/isRecord';

type Props = Omit<LinkProps, 'href'> &
    Omit<SeoLinkProps, 'linkData'> & {
        /** defaults to 'p' */
        defaultTag?: keyof JSX.IntrinsicElements | typeof Fragment;
        href?: string | null;
        linkData?: SeoLinkProps['linkData'] | null;
    };
export const MaybeLink: FC<Props> = ({ defaultTag: Tag = 'p', children, ...props }) => {
    if (isRecordWith(props, 'linkData')) {
        return <SeoLink {...props}>{children}</SeoLink>;
    } else if (isRecordWith(props, 'href')) {
        return <Link {...props}>{children}</Link>;
    } else if (typeof Tag === 'string') {
        return <Tag className={props.className}>{children}</Tag>;
    } else {
        // Tag must be fragment--do not include props
        return <Tag>{children}</Tag>;
    }
};
